/**
 * Mixin used for buttons
 * @mixin
 * @displayName Button Mixin
 */
export default {
  methods: {
    handleClick($event) {
      /**
       * Emits click event with target's event
       * @event click
       * @property {object} $event - Target's Event object
       */
      this.$emit('click', $event);
    }
  }
};
